// 获取注册内容弹窗组件
export function getstateDialogData() {
    return [

        {
            key: "school",
            name: "密码",
            value: '',
            type: 'input',
            isNull: true,

        },


    ]
}